/* Instagram feed (Square app) – gentle continuous auto-scroll on product pages – Oct 2026
   Works on the one-row feed made by instagram-feed-pdp.css (#vitals-end-section).
   Pauses on hover / touch / keyboard focus, only runs while the feed is on screen,
   and is switched off for visitors who ask for reduced motion. */
(function () {
  if (window.__wfIgAuto) return;
  window.__wfIgAuto = true;

  var SPEED = 35; // pixels per second
  var SELECTOR = '#vitals-end-section .Vtl-InstagramFeedLayout__PostList';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(list) {
    if (list.getAttribute('data-wf-auto')) return;
    var originals = Array.prototype.filter.call(list.children, function (c) {
      return !c.hasAttribute('data-wf-clone');
    });
    if (originals.length < 2) return;
    list.setAttribute('data-wf-auto', '1');
    if (reduceMotion) return;

    // Copy the posts once so the row can loop seamlessly. Clicking a copy opens the real post.
    originals.forEach(function (post) {
      var copy = post.cloneNode(true);
      copy.setAttribute('data-wf-clone', '1');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      copy.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        post.click();
      });
      list.appendChild(copy);
    });

    var paused = false, onScreen = true, last = null, pos = list.scrollLeft, resumeTimer;

    function loopWidth() {
      var firstCopy = list.querySelector('[data-wf-clone]');
      return firstCopy ? firstCopy.offsetLeft - originals[0].offsetLeft : list.scrollWidth / 2;
    }
    function pause() { paused = true; clearTimeout(resumeTimer); }
    function resume(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        var w = loopWidth();
        if (list.scrollLeft >= w) list.scrollLeft -= w;
        pos = list.scrollLeft;
        paused = false;
      }, delay || 0);
    }

    list.addEventListener('mouseenter', pause);
    list.addEventListener('mouseleave', function () { resume(300); });
    list.addEventListener('touchstart', pause, { passive: true });
    list.addEventListener('touchend', function () { resume(2500); }, { passive: true });
    list.addEventListener('focusin', pause);
    list.addEventListener('focusout', function () { resume(1000); });
    list.addEventListener('wheel', function () { pause(); resume(2000); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }).observe(list);
    }

    function frame(t) {
      if (!document.documentElement.contains(list)) return;
      if (last !== null && !paused && onScreen && !document.hidden) {
        pos += SPEED * Math.min(t - last, 100) / 1000;
        var w = loopWidth();
        if (w > 0 && pos >= w) pos -= w;
        list.scrollLeft = pos;
      }
      last = t;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function scan() {
    var list = document.querySelector(SELECTOR);
    if (list) setup(list);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
